import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { ROUTES } from '@/constants/routes'

const PAGE_BACK_MAPPING = {
  [ROUTES.OTP]: ROUTES.LOGIN
}

const useBackNavigation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname

  const goBack = useCallback(() => {
    const currentPath = pathname
    const backRoute = PAGE_BACK_MAPPING[currentPath]

    if (backRoute) {
      navigate(backRoute)
    } else {
      window.history.back()
    }
  }, [navigate, pathname])

  return { goBack }
}

export default useBackNavigation
